import React, { useState } from "react";
import { Container, Row, Col, Button, Toast } from "react-bootstrap";
import Particle from "../Particle";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [showToast, setShowToast] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    setShowToast(true); // Show Snackbar/Toast
    setFormData({ name: "", email: "", message: "" }); // Reset form
  };

  return (
    <Container fluid className="contact-section">
      <Container >
      <Particle />

        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={6}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "30px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              <strong className="purple">Contact Me</strong>
            </h1>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="name" className="form-label text-light">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter your name"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="email" className="form-label text-light">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="message" className="form-label text-light">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-control"
                  rows="4"
                  placeholder="Enter your message"
                  required
                ></textarea>
              </div>

              <Button variant="primary" type="submit" className="purple-button">
                Submit
              </Button>
            </form>
          </Col>
        </Row>

        {/* Snackbar/Toast Notification */}
        <Row>
          <Col md={6} className="d-flex justify-content-center">
            <Toast
              onClose={() => setShowToast(false)}
              show={showToast}
              delay={3000}
              autohide
              style={{ position: "fixed", top: "20px", zIndex: "1050" }}
            >
              <Toast.Header>
                <strong className="me-auto">Success</strong>
              </Toast.Header>
              <Toast.Body>
                Thank you for reaching out! I will get back to you soon.
              </Toast.Body>
            </Toast>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default ContactUs;
